import { mapState, mapGetters } from 'vuex'
import EmbedCloudinary2 from '~/components/embeds/EmbedCloudinary2.vue'
import EmbedSanityImage from '~/components/embeds/EmbedSanityImage.vue'
import TranslatableStringComponent from '~~/components/TranslatableStringComponent.vue'
import FavoriteHeart from '~/components/FavoriteHeart.vue'
import InputFieldStepper from '~/components/InputFieldStepper.vue'
import AlertForRealTimeInventory from '~/components/AlertForRealTimeInventory.vue'
import { gtmEvent } from '~/plugins/global'
import handleSnackbar from '~/mixins/handleSnackbar'
import { interpolateDOLStartersSlug } from '~/util/dol-staters-helper'

export default {
    components: {
        EmbedCloudinary2,
        EmbedSanityImage,
        FavoriteHeart,
        InputFieldStepper,
        TranslatableStringComponent,
        AlertForRealTimeInventory,
    },
    mixins: [handleSnackbar],
    props: {
        item: {
            type: Object,
            default: null,
        },
        imgCrop: {
            type: String,
            default: 'fill',
        },
        checkout: {
            type: Boolean,
            default: false,
        },
        shop: {
            type: Boolean,
            default: false,
        },
        isSavedCartItem: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            catalog: {
                products: {},
            },
            dialog: false,
            removableItem: {},
            disabledCheckout: false,
            pkgQtyType: 'standard',
            loading: false,
            itemAddedToCart: false,
            showDialogPriceListMismatch: false,
            showDialogItemPresentInCart: false,
            itemUnavailable: false,
        }
    },
    computed: {
        ...mapState('cart', [
            'unavailableProductList',
            'availibilityChecked',
            'singleProductAvailabilityInElastic',
            'checkingAvailibility',
        ]),
        ...mapState('common', ['siteSettings']),
        ...mapState('customProducts', ['customProductList']),
        ...mapGetters({
            isAuthor: 'auth/isAuthor',
            nonStandardPkgQtyItems: 'cart/nonStandardPkgQtyItems',
            // cartProductsAvailability:
            //     'realTimeInventoryData/fetchCartProductsAvailability',
            cartProducts: 'cart/fetchCartProducts',
            isPriceListMismatched: 'priceList/isPriceListMismatched',
        }),
        isShop() {
            return this.shop
        },
        isCheckout() {
            return this.checkout
        },
        isExemptFromShipping() {
            if (
                this.siteSettings &&
                this.siteSettings.cartItemRules.length > 0
            ) {
                const isFound = this.siteSettings.cartItemRules.find((i) => {
                    if (i.pn && i.pn.includes('*')) {
                        const regEx = new RegExp(`^${i.pn.replace('*', '')}`)
                        return (
                            regEx.test(this.item.pn) && i.exemptFromFreeShipping
                        )
                    } else if (i.pn) {
                        return i.pn === this.item.pn && i.exemptFromFreeShipping
                    } else {
                        return false
                    }
                })
                return !!isFound
            } else {
                return false
            }
        },
        hasLeadTime10Days() {
            if (
                this.siteSettings &&
                this.siteSettings.cartItemRules.length > 0
            ) {
                const isFound = this.siteSettings.cartItemRules.find((i) => {
                    if (i.pn && i.pn.includes('*')) {
                        const regEx = new RegExp(`^${i.pn.replace('*', '')}`)
                        return regEx.test(this.item.pn) && i.leadTime10Days
                    } else if (i.pn) {
                        return i.pn === this.item.pn && i.leadTime10Days
                    } else {
                        return false
                    }
                })
                return !!isFound
            } else {
                return false
            }
        },
        isCustomProduct() {
            return (
                this.customProductList.length > 0 &&
                this.customProductList.find((i) => {
                    return i.hash === this.item.hash
                })
            )
        },
        customInputString() {
            return (
                this.isCustomProduct &&
                this.isCustomProduct.legendPlateInput
                    .map((item) => item.value.trim())
                    .join(' / ')
            )
        },
        isFlexibleQuantity() {
            return ['wire-duct'].includes(this.item.parent?.en.current)
        },
        // realTimeInventoryProductAvailability() {
        //     return this.cartProductsAvailability.find(
        //         (product) => product.partNumberErp === this.item.pn
        //     )
        // },
        isItemEligibleToAddToCart() {
            return this.item.pkgqty && this.item.parent
        },
        savedCartItemFromElasticSearch() {
            return {
                ...this.singleProductAvailabilityInElastic[0],
                quantityInCart: this.item.quantityInCart,
            }
        },
    },
    watch: {
        item(newVal, oldVal) {
            if (newVal.quantityInCart !== oldVal.quantityInCart) {
                this.$store.dispatch(
                    'realTimeInventoryData/updateDataStateForAvailability',
                    { pn: this.item.pn }
                )
                this.$store.dispatch(
                    'realTimeInventoryData/debounceCartItemQtyChange',
                    { products: this.cartProducts, source: 'cart' }
                )
            }
        },
        savedCartItemFromElasticSearch(newVal, oldVal) {
            if (newVal.length > 0 && this.isSavedCartItem) this.item
        },
    },
    mounted() {
        this.handlePkgQtyType()
    },
    methods: {
        addToCartSavedItem() {
            const isPresentInCart = this.cartProducts.find(
                (cartItem) => cartItem.pn === this.item.pn
            )
            if (isPresentInCart) {
                this.showDialogItemPresentInCart = true
                return
            } else if (this.isPriceListMismatched)
                this.showDialogPriceListMismatch = true
            else this.proceedAddToCart()
        },
        async proceedAddToCart() {
            await this.$store.dispatch(
                'cart/checkProductAvailibilityInElastic',
                {
                    products: [this.item],
                    singleProduct: true,
                }
            )
            if (this.savedCartItemFromElasticSearch?.isAvailable) {
                this.$store.dispatch(
                    'cart/updateCart',
                    this.savedCartItemFromElasticSearch
                )
                this.itemAddedToCart = true
            }
            if (!this.savedCartItemFromElasticSearch.isAvailable)
                this.itemUnavailable = true
            this.showDialogPriceListMismatch = false
        },
        removePricelist() {
            this.$store.commit('priceList/setSelectedPriceListId', '')
            this.$store.commit('priceList/setAppliedPriceList', [])
            this.proceedAddToCart()
        },
        addToCart() {
            this.$store.dispatch('cart/updateCart', this.item)
            gtmEvent({
                gtm: this.$gtm,
                event: 'addToCart',
                eventType: 'click',
                atts: {
                    c3source: 'shop',
                    ecommerce: {
                        currencyCode: 'USD',
                        add: {
                            products: [
                                {
                                    id: this.item.pn,
                                    name: this.item.name_en,
                                    price: this.item.sale_price.toFixed(2),
                                    category:
                                        this.item.categories &&
                                        this.item.categories[0]
                                            ? this.item.categories[0]
                                            : 'not recorded',
                                    product_id: this.item.product_id,
                                },
                            ],
                        },
                    },
                },
            })
        },
        createPartNumberToSlug(pn) {
            return pn.replace('/', '_')
        },
        createProductLink(item) {
            if (item.parent) {
                const path = this.localePath({
                    name: 'products-slug',
                    params: {
                        slug: interpolateDOLStartersSlug(
                            item.parent[this.$i18n.locale].current
                        ),
                    },
                })
                if (this.isCustomProduct) {
                    return `${path}/${item.pn}/?isCustom=${this.isCustomProduct.hash}`
                } else {
                    return `${path}/${item.pn}/`
                }
            } else {
                return ''
            }
        },
        createPartialProductLink(item) {
            if (item.parent) {
                const path = this.localePath({
                    name: 'products-slug',
                    params: {
                        slug: item.parent[this.$i18n.locale].current,
                        pn: item.partialSlug,
                    },
                })
                return `${path}/${item.partialSlug}/`
            } else {
                return ''
            }
        },
        initRemoval() {
            this.dialog = true
            if (!this.item) return
            this.removableItem = this.item
        },
        removeItem() {
            this.$store.dispatch('cart/removeItem', this.removableItem)
            this.dialog = false
        },
        isAvailable(item) {
            if (item.isAvailable || this.isShop || this.isSavedCartItem) {
                return true
            } else if (
                this.isCheckout &&
                this.unavailableProductList &&
                this.unavailableProductList.includes(item._id)
            ) {
                return false
            }
        },
        handleEdit(item) {
            if (item.parent && item.product_id) {
                const path = this.localePath({
                    name: 'products-slug',
                    params: {
                        slug: interpolateDOLStartersSlug(
                            item.parent[this.$i18n.locale].current
                        ),
                    },
                })
                const encodedItemId = encodeURIComponent(item.product_id)
                if (this.isCustomProduct) {
                    return `${path}/${item.pn}/?isEdit=${encodedItemId}&isCustom=${this.isCustomProduct.hash}`
                } else {
                    return `${path}/${item.pn}/?isEdit=${encodedItemId}`
                }
            } else {
                return ''
            }
        },
        handleClipboard() {
            navigator.clipboard.writeText(this.item.pn)
            this.hitSnackbar({ string: 'partNumberCopiedSuccessfully' }, null)
        },
        handlePkgQtyType() {
            if (
                this.nonStandardPkgQtyItems.length > 0 &&
                this.nonStandardPkgQtyItems.includes(this.item.pn)
            ) {
                this.pkgQtyType = 'non-standard'
            }
        },
        // async checkProductAvailability() {
        //     this.loading = true
        //     await this.$store.dispatch(
        //         'realTimeInventoryData/checkProductAvailabilityInRealTimeInventory',
        //         {
        //             products: [
        //                 {
        //                     pn: this.item.pn,
        //                     quantityInCart: this.item.prod_quantity,
        //                 },
        //             ],
        //         }
        //     )
        //     this.loading = false
        // },
    },
}
